import { useGetSpaces, useSpace } from '@/entities/teamspace';
import { useCurrentUser, useSettings } from '@/entities/user/currentUser';

export const useSubscriptionDowngraded = () => {
  const { data: currentSpace } = useSpace();
  const { data: spaces } = useGetSpaces();
  const { data: userId } = useCurrentUser((u) => u.id);
  const settings = useSettings();

  if (!spaces || !userId || !currentSpace || !settings) return false;

  if (currentSpace.owner_id !== userId) return false;

  if (currentSpace.is_default) return false;

  const ownSpacesCount = spaces.filter((space) => space.owner_id === userId).length;

  if (ownSpacesCount === 1) return false;

  const { metadata } = settings.scope_settings.available_features.spaces;

  return (!metadata.limit && ownSpacesCount > 1) || (metadata.limit ?? 1) < ownSpacesCount;
};
